import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import "./projectsPage.css";

const ProjectsPage = () => {
	return (
		<div className="projects-page">
			<h1>My Projects</h1>
			<div className="projects-item">
				<div className="projects-content">
					<h2>A simple Pokémon battle simulator.</h2>
					<p>- Built fully on the frontend using ReactJS.</p>
					<p>
						- Can select any Pokémon up to generation 5 alongside up
						to 4 moves of your choice to bring along into the
						battle.
					</p>
					<p>
						- Select your enemy's Pokémon and moves so that you can
						start the battle simulator and fight a simple AI in a
						turn-based battle.
					</p>
					<p>
						<a
							className="link"
							href="https://github.com/ClaudeNi/Pokemon-MidWeek-React"
							rel="noreferrer"
							target="_blank"
						>
							Source Code
						</a>
					</p>
				</div>
				<Carousel infiniteLoop={true}>
					<div>
						<img
							src={require("../../assets/projects images/pokemon/homepage.png")}
							alt="Pokemon Home screen"
							loading="lazy"
						/>
					</div>
					<div>
						<img
							src={require("../../assets/projects images/pokemon/titlescreen.png")}
							alt="Pokemon Title screen"
							loading="lazy"
						/>
					</div>
					<div>
						<img
							src={require("../../assets/projects images/pokemon/pokemonpage.png")}
							alt="Pokemon select screen"
							loading="lazy"
						/>
					</div>
					<div>
						<img
							src={require("../../assets/projects images/pokemon/battlepage.png")}
							alt="Pokemon battle screen"
							loading="lazy"
						/>
					</div>
				</Carousel>
			</div>
			<div className="projects-item">
				<div className="projects-content">
					<h2>A 2D Roguelike game with random level generation.</h2>
					<p>
						- A Full-Stack project built using ReactJS, NodeJS and
						MongoDB.
					</p>
					<p>
						- Random level generation with random enemy placement.
					</p>
					<p>
						- Can move around and finish the level by reaching the
						stairs.
					</p>
					<p>
						- Save your progress whenever and wherever using
						MongoDB.
					</p>
					<p>
						- Change the art style between ASCII and pixel art drawn
						by me.
					</p>
					<p>
						<a
							className="link"
							href="https://github.com/ClaudeNi/Roguelike-Final-Project"
							rel="noreferrer"
							target="_blank"
						>
							Source Code
						</a>
					</p>
				</div>
				<Carousel infiniteLoop={true}>
					<div>
						<img
							src={require("../../assets/projects images/roguelike/1 login.png")}
							alt="Roguelike Login screen"
							loading="lazy"
						/>
					</div>
					<div>
						<img
							src={require("../../assets/projects images/roguelike/2 title.png")}
							alt="Roguelike Title screen"
							loading="lazy"
						/>
					</div>
					<div>
						<img
							src={require("../../assets/projects images/roguelike/3 game.png")}
							alt="Roguelike Game ASCII screen"
							loading="lazy"
						/>
					</div>
					<div>
						<img
							src={require("../../assets/projects images/roguelike/4 game.png")}
							alt="Roguelike Game Pixel art screen"
							loading="lazy"
						/>
					</div>
				</Carousel>
			</div>
			<div className="projects-item">
				<div className="projects-content">
					<h2>A Gen 1 Pokedex.</h2>
					<p>
						- Built fully on the frontend using NextJS and
						TypeScript.
					</p>
					<p>- Includes the first 151 Pokemon of Generation 1.</p>
					<p>
						- Can view the base stats of every Pokemon included and
						its picture.
					</p>
					<p>
						<a
							className="link"
							href="https://github.com/ClaudeNi/pokedex-nextjs"
							rel="noreferrer"
							target="_blank"
						>
							Source Code
						</a>
					</p>
				</div>
				<Carousel infiniteLoop={true}>
					<div>
						<img
							src={require("../../assets/projects images/pokedex nextjs/1 menu.png")}
							alt="Pokedex Menu screen"
							loading="lazy"
						/>
					</div>
					<div>
						<img
							src={require("../../assets/projects images/pokedex nextjs/2 pokepage.png")}
							alt="Pokedex Pokemon screen"
							loading="lazy"
						/>
					</div>
				</Carousel>
			</div>
			<div className="projects-item">
				<div className="projects-content">
					<h2>Dynamic loading Picross game.</h2>
					<p>- Built using Godot and GDscript.</p>
					<p>
						- Dynamically loads a puzzle from a black and white
						image instead of using a JSON object.
					</p>
					<p>- Play 6 levels created by me, 3 10x10 and 3 15x15.</p>
					<p>
						<a
							className="link"
							href="https://claude-ni.itch.io/picross"
							rel="noreferrer"
							target="_blank"
						>
							Game page on Itch.io
						</a>
					</p>
					<p>
						<a
							className="link"
							href="https://github.com/ClaudeNi/Dynamic-Picross-Godot"
							rel="noreferrer"
							target="_blank"
						>
							Source Code
						</a>
					</p>
				</div>
				<Carousel infiniteLoop={true} showThumbs={false}>
					<div>
						<img
							src={require("../../assets/projects images/picross/1 main_menu.png")}
							alt="Picross game main menu screen"
							loading="lazy"
						/>
					</div>
					<div>
						<img
							src={require("../../assets/projects images/picross/2 level_select.png")}
							alt="Picross game level select screen"
							loading="lazy"
						/>
					</div>
					<div>
						<img
							src={require("../../assets/projects images/picross/3 level.png")}
							alt="Picross game level screen"
							loading="lazy"
						/>
					</div>
					<div>
						<img
							src={require("../../assets/projects images/picross/4 options_screen.png")}
							alt="Picross game options screen"
							loading="lazy"
						/>
					</div>
				</Carousel>
			</div>
			<div className="projects-item">
				<div className="projects-content">
					<h2>A 2D Action RPG pixel art game.</h2>
					<p>- Built using Godot and GDscript.</p>
					<p>- Explore a small world filled with enemies.</p>
				</div>
				<Carousel infiniteLoop={true}>
					<div>
						<img
							src={require("../../assets/projects images/action rpg/ARPG_1.png")}
							alt="Action RPG showcase 1"
							loading="lazy"
						/>
					</div>
					<div>
						<img
							src={require("../../assets/projects images/action rpg/ARPG_2.png")}
							alt="Action RPG showcase 2"
							loading="lazy"
						/>
					</div>
					<div>
						<img
							src={require("../../assets/projects images/action rpg/ARPG_3.png")}
							alt="Action RPG showcase 3"
							loading="lazy"
						/>
					</div>
				</Carousel>
			</div>
			<div className="projects-item">
				<div className="projects-content">
					<h2>A fanmade Ace Attorney spinoff clicker game.</h2>
					<p>- Made in Godot using GDscript.</p>
					<p>- Includes a dialogue system.</p>
				</div>
				<Carousel infiniteLoop={true}>
					<div>
						<img
							src={require("../../assets/projects images/aa clicker/AA_Clicker_1.png")}
							alt="Ace Attorney Clicker showcase 1"
							loading="lazy"
						/>
					</div>
					<div>
						<img
							src={require("../../assets/projects images/aa clicker/AA_Clicker_2.png")}
							alt="Ace Attorney Clicker showcase 2"
							loading="lazy"
						/>
					</div>
					<div>
						<img
							src={require("../../assets/projects images/aa clicker/AA_Clicker_3.png")}
							alt="Ace Attorney Clicker showcase 3"
							loading="lazy"
						/>
					</div>
				</Carousel>
			</div>
		</div>
	);
};

export default ProjectsPage;
